module.exports = __webpack_public_path__ + "media/02_ASANBUDAPEST-BASS02.6391131b.mp3";